<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <page-header
      title="Użytkownicy"
      subtitle="Panel administratora"
      buttonLabel="Dodaj użytkownika"
      buttonLink="/admin/users/new"
      backButtonLabel="Wróć"
      backButtonLink="/admin/" />

    <d-row
      style="width: 100%;"
      class="d-flex ml-0 mb-3 page-filters">
      <validation-observer
        ref="users-filters-form"
        tag="form"
        style="width: 100%;"
        class="d-flex">
        <d-input
          placeholder="Podaj imię, nazwisko lub e-mail użytkownika"
          v-model="filters.search" />

        <d-button
          theme="success"
          outline
          class="text-nowrap ml-2"
          @click.prevent="validateFiltersForm">Szukaj</d-button>

        <d-button
          theme="danger"
          outline
          class="text-nowrap ml-2"
          @click.prevent="clearFilters">Resetuj filtry</d-button>
      </validation-observer>
    </d-row>

    <d-card style="width: 100%;">
      <table class="table mt-0 mb-0 full-width">
        <thead class="thead-dark">
          <tr>
            <sortable-table-heading field="surname" view="users" :column="orderColumn" :direction="orderDirection">Imię i nazwisko</sortable-table-heading>
            <sortable-table-heading field="email" view="users" :column="orderColumn" :direction="orderDirection">Adres e-mail</sortable-table-heading>
            <th scope="col" class="border-0">Akcje</th>
          </tr>
        </thead>
        <tbody v-if="loaded">
          <tr
            v-for="(user, index) of users"
            :key="'user-' + index">
            <td class="align-middle">
              <router-link :to="'/admin/users/' + user.id">
                {{ user.name }} {{ user.surname }}
              </router-link>
            </td>
            <td class="align-middle">
              {{ user.email }}
            </td>
            <td
              class="align-middle"
              style="width: 150px;">
              <d-button
                theme="dark"
                @click.native="$router.push('/admin/users/' + user.id)"
                class="mr-2"
                title="Edytuj">
                <i class="material-icons">edit</i>
              </d-button>
              <d-button
                theme="danger"
                :disabled="removeInProgress || user.id === currentUserID"
                @click.native="removeUser(user.id)"
                title="Usuń">
                <i class="material-icons">delete</i>
              </d-button>
            </td>
          </tr>
          <tr v-if="users.length === 0">
            <td
              colspan="5"
              class="text-center">
              Brak użytkowników do wyświetlenia&hellip;
            </td>
          </tr>
        </tbody>
      </table>

      <div v-if="!loaded" class="pb-3 pt-3 text-center">
        Trwa ładowanie danych&hellip;
      </div>

      <d-alert
        v-if="loadError"
        show
        theme="warning">
        Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
      </d-alert>
    </d-card>

    <pagination :meta-data="paginationMetaData" />
  </d-container>
</template>

<script>
import debounce from 'lodash.debounce';
import FormUtils from './../utils/FormUtils.js';
import HasFilters from './../mixins/HasFilters.vue';
import HasPagination from './../mixins/HasPagination.vue';
import ListUtils from './../utils/ListUtils.js';
import Pagination from './../components/common/Pagination.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'users',
  mixins: [
    HasFilters,
    HasPagination
  ],
  components: {
    'pagination': Pagination
  },
  computed: {
    ...mapGetters('user', [
      'currentUserID'
    ])
  },
  data() {
    return {
      users: [],
      loaded: false,
      loadError: false,
      removeInProgress: false,
      filters: {
        search: ''
      }
    };
  },
  mounted () {
    this.loadFilteredData();
  },
  methods: {
    debouncedLoadFilteredData: debounce(function () {
      this.$bus.emit('view-filters-save');
      this.loadFilteredData();
    }, 250),
    loadFilteredData () {
      let where = {
        search: this.filters.search
      };

      ListUtils.loadItemsData(this, {
        endpoint: '/system/users/items?page=' + this.currentPage,
        listField: 'users',
        pagination: true,
        params: {
          where,
          order: {
            column: this.orderColumn,
            direction: this.orderDirection
          }
        }
      });
    },
    clearFilters () {
      this.loaded = false;
      this.loadError = false;
      this.filters = {
        search: ''
      };

      this.loadFilteredData();
      this.$bus.emit('view-filters-reset');
    },
    validateFiltersForm () {
      this.$bus.emit('pagination-reset');
      FormUtils.validate(this.$refs['users-filters-form'], this.debouncedLoadFilteredData);
    },
    removeUser (userID) {
      this.removeInProgress = true;

      ListUtils.removeItem(this, {
        endpointBase: '/system/users/delete/',
        id: userID,
        successTitle: 'Usunięto użytkownika',
        successText: 'Wybrany użytkownik został usunięty',
        confirmTitle: 'Czy na pewno chcesz usunąć tego użytkownika?',
        confirmText: 'Tej operacji nie można cofnąć',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Usuwanie użytkownika nie powiodło się. Spróbuj ponownie.',
        successAction: () => {
          this.removeInProgress = false;
          this.loadFilteredData();
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    }
  }
};
</script>

